import styles from './leftMenu.module.scss';
import { useTranslation } from "react-i18next";
import { ScenarioMenu } from "../../scenarioMenu/scenarioMenu";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  AppDispatch,
  RootState
} from "../../../store";
import { deleteSelectedTestCaseTemplate } from "../../../store/slices/testCaseTemplateSlice";
import { deleteScenario } from "../../../store/slices/scenarioSlice";
import { TestPlanMenu } from "../../testPlanMenu/testPlanMenu";
import { deleteTestPlan } from "../../../store/slices/testPlanSlice";
import { setSelectedTab } from "../../../store/slices/mainSlice";
import { TestCaseRegularMenu } from "../../testCaseRegularMenu/testCaseRegularMenu";
import { TestCaseIncomingMenu } from "../../testCaseIncomingMenu/testCaseIncomingMenu";
import { deleteSelectedTestCaseIncoming } from "../../../store/slices/testCaseIncomingSlice";
import { TabsConstants } from "../../../constants/tabs.constants";
import {
  useMemo,
  useRef
} from "react";
import { findProjectSettings } from "../../../store/selectors";

type TabType = {
  tab: TabsConstants
  title: string,
  child: JSX.Element
}

export const LeftMenu = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const selectedTab = useSelector((state: RootState) => findProjectSettings(state).selectedTab);

  const tabs = useRef<Array<TabType>>([
    {
      tab: TabsConstants.testCase,
      title: t("common.cases"),
      child: <TestCaseRegularMenu />
    },
    {
      tab: TabsConstants.scenario,
      title: t("common.scenarios"),
      child: <ScenarioMenu />
    },
    {
      tab: TabsConstants.testPlan,
      title: t("common.plans"),
      child: <TestPlanMenu />
    },
    {
      tab: TabsConstants.testCaseIncoming,
      title: t("common.incomingCases"),
      child: <TestCaseIncomingMenu />
    },
  ]);


  const onClickTab = (tabType: TabType): void => {
    if (selectedTab !== tabType.tab) {
      dispatch(deleteSelectedTestCaseTemplate());
      dispatch(deleteScenario());
      dispatch(deleteTestPlan());
      dispatch(deleteSelectedTestCaseIncoming())

      dispatch(setSelectedTab(tabType.tab));
    }
  }

  const selectedTabChild = useMemo(() => {
    return tabs.current.find(item => item.tab === selectedTab)?.child;
  }, [selectedTab]);

  return (
    <div className={styles.container}>
      <div className={styles.tabs} >
      { tabs.current.map((tabType, index) => {
        return (
          <div className={`${styles.tab} ${selectedTab === tabType.tab ? styles.selected : ""}`}
               key={index}
               onClick={() => onClickTab(tabType)}>
            {tabType.title}
          </div>
        )
      })}
      </div>
      {selectedTabChild}
    </div>
  )
}